import { render, staticRenderFns } from "./TokenDialog.vue?vue&type=template&id=cae8b1c8&scoped=true"
import script from "./TokenDialog.vue?vue&type=script&lang=js"
export * from "./TokenDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cae8b1c8",
  null
  
)

export default component.exports